import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import { getModuleMaxLimit } from "utils/pageModulesUtils";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    style: PropTypes.string,
    algoliaCard: AlgoliaCardsPresenter.shape(),
  },
  {
    hitsPerPage(module, algoliaLimit) {
      return Math.min(getModuleMaxLimit(module), algoliaLimit);
    },
    algoliaCardFromPageModule(module) {
      return module?.algoliaCard?.data?.attributes;
    },
    isTopRanking(categoryRow) {
      return categoryRow.style === "rank";
    },
  },
);
